import {
    QueryVisitOrdersArgs,
    VisitOrderFilter,
    VisitOrderOrdering,
    VisitOrderState,
} from 'gql-types';

/**********************
 * Visit Order Types
 *********************/
export namespace VisitOrder {
    /** @deprecated Use VisitOrderFilter imported from 'gql-types' */
    export type Filters = VisitOrderFilter;
    /** @deprecated Use VisitOrderOrdering imported from 'gql-types' */
    export type Ordering = VisitOrderOrdering;
    /** @deprecated Use QueryVisitOrdersArgs imported from 'gql-types' */
    export type ListVariables = QueryVisitOrdersArgs;
}

export const renderVisitOrderState = (state: VisitOrderState): string => {
    switch (state) {
        case VisitOrderState.DRAFT:
            return 'Draft';
        case VisitOrderState.NEEDS_ATTENTION:
            return 'Needs Attention';
        case VisitOrderState.ACTIVE:
            return 'Active';
        case VisitOrderState.NEEDS_OUTCOME:
            return 'Needs Outcome';
        case VisitOrderState.ENDED:
            return 'Ended';
        default:
            return 'Unknown';
    }
};
